import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { SC_Input } from '../../../common/input/SC_Input';
import ColorLib from '../../../common/lib/ColorLib';
import { CombinationBuffer } from '../../../common/lib/CombinationBuffer';
import { Inverter } from '../../../common/lib/Inverter';
import { InverterCombination, InverterCombinator } from '../../../common/lib/InverterCombinator';
import { InverterSetup } from '../../../common/lib/InverterSetup';
import { InverterSetupBase } from '../../../common/lib/InverterSetupBase';
import { InverterSetupMPPTracker } from '../../../common/lib/InverterSetupMPPTracker';
import { MultipleInverter } from '../../../common/lib/MultipleInverter';
import { SolarPanel } from '../../../common/lib/SolarPanel';
import { GlobalService } from "../../../common/services/global.service";
import { GlobalVariableService } from "../../../common/variables/global-variable";
import { TranslateService } from "../../../common/variables/translate-service";
import { getAllInverters } from '../../../store/senAppProjects.action';
declare var randomColor: any;

@Injectable()
export class SearchInverterService {
    cosPhi: number;
    panelCount: number;
    combinator: InverterCombinator;
    factorMin: number;
    factorMax: number;
    tempMin: number = -10;
    tempMax: number = 70;
    selectedPanel: SolarPanel;
    selectedInverterList: Inverter[][] = [];
    allInvertersList: any[] = [];
    inverterGroups: any[] = [];

    constructor(private globalService: GlobalService,
        public translate: TranslateService,
        public global: GlobalVariableService,
        private store: Store<any>) {

    }

    setPanelCount(count: number) {
        this.panelCount = count;
    }

    setCosPhi(cosPhi: number) {
        this.cosPhi = cosPhi;
    }

    setFactor(min: number, max: number) {
        this.factorMin = min;
        this.factorMax = max;
    }

    selectPanel(panel: SolarPanel) {
        this.selectedPanel = panel;
    }

    selectInverters(valList: any[]) {
        this.selectedInverterList = [];
        if (valList.length > 0) {
            let allSelectedInverters: Inverter[] = [];
            for (let inv of this.allInvertersList) {
                let found = valList.some((val: any) => inv.name.lastIndexOf(val.name, 0) === 0);
                if (found) {
                    allSelectedInverters.push(inv);
                }
            }
            // Fill list
            // this.selectedInverterList.push(allSelectedInverters);
            for (let i = 0; i < valList.length; i++) {
                let groupName = valList[i].name;
                let groupedInverters = allSelectedInverters.filter(inv => inv.name.lastIndexOf(groupName, 0) === 0);
                this.selectedInverterList.push(groupedInverters);
            }
        } else {
        }
    }


    addMpptToSetups(setups: InverterSetupBase[], counter: number) {
        let subGen: any[] = [];
        setups.forEach((g: any, ind: number) => {
            ++counter;
            let pCount: number = 0;
            let tempG: any = {};
            let shade = 0.0;
            tempG.name = `${this.translate.getLng('SUB_GENERATOR')} ${counter}`;
            tempG.color = randomColor({ luminosity: 'dark' });
            tempG.inverterID = parseInt(g.invID);
            tempG.dcCableLength = NaN;
            tempG.strings = [];
            tempG.mppt = [];
            let stringCount = 0;
            let labelCount = 1;
            for (let tracker of g.mppTrackers) {
                stringCount += tracker.stringCount;
            }
            let shadeStep = ColorLib.calculateShadeStep(stringCount);
            g.mppTrackers.forEach((m: any) => {
                pCount += m.panelCount * m.stringCount;
                tempG.mppt.push({
                    trackerIndex: 0,
                    stringCount: m.stringCount,
                    panelCountPerString: m.panelCount
                });
                for (let i = 0; i < m.stringCount; i++) {
                    let stringColor = ColorLib.shadeColor(tempG.color, shade);
                    if (labelCount % 4 == 0) { // at every 4th step it reset color to orignal since the color dilution makes the color to white
                        shade = 0.0;
                    } else {
                        shade += shadeStep;
                    }
                    tempG.strings.push({
                        name: `${this.translate.getLng('INV_STRING')} ${ind + 1}.${labelCount}`,
                        color: stringColor,
                        panelCount: m.panelCount,
                        nodes: null
                    });
                    ++labelCount;
                }
            });
            tempG.panelCount = pCount;
            subGen.push(tempG);
        });
        return subGen;
    }

    getAllInverter() {
        const qParam = {
            cmd: this.global.InverterGetAll,
        };
        this.globalService.getData(qParam).subscribe((data: any) => {
            try {
                if (data.ok.data) {
                    let id = 0;
                    let combinatorF = new InverterCombinator(this.tempMin, this.tempMax, (SC_Input.sInverter.dimensionMin / 100) * SC_Input.sInverter.cosPhi, (SC_Input.sInverter.dimensionMax / 100) * SC_Input.sInverter.cosPhi);
                    data.ok.data.inverters.forEach((item: any, index: number) => {
                        item.minPanel = combinatorF.getMinPanelCount(SC_Input.sPanel, item);
                        item.maxPanel = combinatorF.getMaxPanelCount(SC_Input.sPanel, item);
                    });
                    this.allInvertersList = data.ok.data.inverters;
                    this.store.dispatch(getAllInverters([data.ok.data.inverters]));
                    this.inverterGroups = data.ok.data.inverterGroups;
                }
            } catch { }
        })
    }

    listCombinations() {
        let t = Date.now();
        let id = 0;
        let result: { id: number; combi: string; setups: InverterSetupBase[] }[] = [];
        this.selectedPanel = SC_Input.sPanel;
        for (let inverters of this.selectedInverterList) {
            let buffer = this.getBuffer(inverters, this.cosPhi);
            let combination: InverterSetupBase[] = [];
            this.getCombinations(this.panelCount, buffer, combination);
            if (combination.length > 0) {
                id++;
                let combi = "";
                combi = this.getUniqueCombinationString(combination);
                result.push({
                    id: id,
                    combi: combi,
                    setups: combination
                });
            }
        }
        t = Date.now() - t;
        // console.log("time: " + t);
        return result;
    }

    getBuffer(inverters: Inverter[], reactivePower: number): CombinationBuffer {
        let combinator: InverterCombinator = new InverterCombinator(this.tempMin, this.tempMax, this.factorMin * reactivePower, this.factorMax * reactivePower);
        this.combinator = combinator;
        let buffer: CombinationBuffer = new CombinationBuffer();
        for (let inv of inverters) {
            let combinations = combinator.getCombinations(this.selectedPanel, inv, true);
            let maxRowCount = 0;
            for (let combination of combinations) {
                let panelCount = 0;
                for (let tracker of combination.mppTrackers) {
                    panelCount += tracker.stringCount * tracker.panelCount;
                }
                if (typeof buffer.map[panelCount] === typeof undefined) {
                    buffer.map[panelCount] = [];
                }
                // Add inverter index
                buffer.map[panelCount].push(new MultipleInverter(inv.id!, 1));
                // Multiple
                let panelCountMulti: number = 0;
                for (let i = 2; i <= 100; i++) {
                    panelCountMulti = panelCount * i;
                    if (typeof buffer.map[panelCountMulti] === typeof undefined) {
                        buffer.map[panelCountMulti] = [];
                    }
                    buffer.map[panelCountMulti].push(new MultipleInverter(inv.id!, i));
                }
                // Set min and max panel count
                if (buffer.panelCountMin > panelCount) {
                    buffer.panelCountMin = panelCount;
                }
                if (buffer.panelCountMax < panelCountMulti) {
                    buffer.panelCountMax = panelCountMulti;
                }
                if (buffer.map[panelCount].length > maxRowCount) {
                    maxRowCount = buffer.map[panelCount].length;
                }
            }
        }
        return buffer;
    }

    getCombinations(panelCount: number, buffer: CombinationBuffer, combiDuoList: InverterSetupBase[]) {
        if (panelCount < buffer.panelCountMin) {
            // TODO: check if null is appropriate
            // combiDuoList.push(null!);
            return;
        }
        if (typeof buffer.map[panelCount] == typeof undefined) {
            let rest = panelCount % 2;
            let low = panelCount / 2 | 0;
            let high = low + rest;
            let first = low;
            let second = high;
            if (low >= buffer.panelCountMin && high <= buffer.panelCountMax) {
                low = buffer.panelCountMin;
                high = panelCount - low;
                while (low <= high) {
                    if (typeof buffer.map[low] !== typeof undefined && typeof buffer.map[high] !== typeof undefined) {
                        this.fillCombination(low, buffer, combiDuoList);
                        this.fillCombination(high, buffer, combiDuoList);
                        return;
                    }
                    low++;
                    high--;
                }
            }
            this.getCombinations(first, buffer, combiDuoList);
            this.getCombinations(second, buffer, combiDuoList);
        } else {
            if (buffer.map[panelCount].length > 0) {
                this.fillCombination(panelCount, buffer, combiDuoList);
            }
        }
    }

    private fillCombination(panelCount: number, buffer: CombinationBuffer, combiDuoList: InverterSetupBase[]) {
        let bestIndex: number = 0, lowestCount: number = 999;
        for (let i = 0; i < buffer.map[panelCount].length; i++) {
            if (buffer.map[panelCount][i].count < lowestCount) {
                lowestCount = buffer.map[panelCount][i].count;
                bestIndex = i;
            }
        }
        let panelCountPerInv = panelCount / buffer.map[panelCount][bestIndex].count | 0;
        for (let i = 0; i < buffer.map[panelCount][bestIndex].count; i++) {
            // let name = InverterModel.getInverter(buffer.map[panelCount][bestIndex].invID).name;
            let name = _.find(this.allInvertersList, { id: buffer.map[panelCount][bestIndex].invID }).name;
            combiDuoList.push(new InverterSetupBase(panelCountPerInv, buffer.map[panelCount][bestIndex].invID, name));
        }
    }

    getUniqueCombinationString(combiDuoList: InverterSetupBase[]): string {
        let result = "";
        let hash: { [invID: string]: number } = {};
        for (let combiDuo of combiDuoList) {
            if (combiDuo) {
                if (typeof hash[combiDuo.invID!] === typeof undefined) {
                    hash[combiDuo.invID!] = 1;
                } else {
                    hash[combiDuo.invID!]++;
                }
            }
        }
        let first = true;
        for (let invID in hash) {
            // let invName = InverterModel.getInverter(invID).name;
            if (invID != 'null') {
                let invName = _.find(this.allInvertersList, { id: parseInt(invID) }).name;
                if (first) {
                    first = false;
                    result += hash[invID] + ' x ' + invName;
                } else {
                    result += ", " + hash[invID] + ' x ' + invName;
                }
            }
        }
        return result;
    }

    generateSetupCombination(setups: InverterSetupBase[]) {
        let result: InverterSetup[] = [];
        for (let setupBase of setups) {
            let name = _.find(this.allInvertersList, { id: setupBase.invID }).name;
            // let name = InverterModel.getInverter(setupBase.invID).name;
            let setup = new InverterSetup(setupBase.panelCount, setupBase.invID, name);
            let combination = new InverterCombination;
            // let inverter = InverterModel.getInverter(setupBase.invID);
            let inverter = _.find(this.allInvertersList, { id: setupBase.invID });
            if (!this.combinator) {
                this.combinator = new InverterCombinator(this.tempMin, this.tempMax, this.factorMin * this.cosPhi, this.factorMax * this.cosPhi);
            }
            let combinations = this.combinator.generateSingleTrackerCombinations(inverter, this.selectedPanel, setupBase.panelCount);
            if (combinations.length == 0) {
                combinations = this.combinator.generateMultiTrackerCombinations(inverter, this.selectedPanel, setupBase.panelCount);
            }
            if (combinations.length > 0) {
                combination = combinations[0];
            }
            for (let i = 0; i < inverter.mppt!.length; i++) {
                let tracker: InverterSetupMPPTracker;
                tracker = new InverterSetupMPPTracker(0, 0);
                if (combination != null) {
                    if (typeof combination.mppTrackers[i] !== typeof undefined) {
                        tracker = combination.mppTrackers[i];
                    }
                }
                setup.mppTrackers.push(tracker);
            }
            result.push(setup);
        }
        return result;
    }
}